import { PropsWithChildren } from 'react';

export default function Chip({ children }: PropsWithChildren) {
  return (
    <span className="inline-flex items-center rounded-md border border-outline-variant bg-surface-container-low px-2 py-1 label-md text-on-surface-variant">
      {children}
    </span>
  );
}
